export const USER_NAV =  [
  {
    title: 'Akun Saya',
    link: '#',
    rel: 'account',
    childItems: [
      {
        title: "Pengajuan",
        link: "/accounts/applications",
        position: "right",
      },
      {
        title: "Polis Saya",
        link: "/accounts/policy",
        position: "right",
      },
      {
        title: "Profil",
        link: "/accounts/profile",
        position: "right",
      }, 
    ]
  }
];

export const LOGOUT_NAV = {
  title: "Keluar",
  link: "",
  position: "right",
};
